import React, { Component } from 'react';

class Analytics extends Component {

  render() {
    return (
      <div className='animated fadeIn'>
        <div
          className=''
          style={{
            // width: '90%',
            margin: '10px auto 0 auto',
          }}
        >
          <iframe title="Account Management Report" width="100%" height="1200px" src="https://app.powerbi.com/view?r=eyJrIjoiYmZkOTg3MWMtNTVjOC00NmI4LWEwYmEtMmJiMTRiMzVmYzliIiwidCI6IjA4YTAxMTI2LWI2M2ItNDliYS05YTExLTY0NGJkNDE0NDg3NyIsImMiOjF9" frameborder="0" allowFullScreen="true"></iframe>
          <iframe title="HR Analytics" width="100%" height="1200px" src="https://app.powerbi.com/view?r=eyJrIjoiYTQ2ODdmOWUtMzc0Yi00ZDhlLTg0NjktOTlkNDFkNmU4NjI3IiwidCI6IjA4YTAxMTI2LWI2M2ItNDliYS05YTExLTY0NGJkNDE0NDg3NyIsImMiOjF9" frameborder="0" allowFullScreen="true"></iframe>
        </div>
      </div>  
    )
  }
};

export default (Analytics);
